import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { ElegirTarjetaLazoPage } from './elegir-tarjeta-lazo.page';

const routes: Routes = [
  {
    path: '',
    component: ElegirTarjetaLazoPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [ElegirTarjetaLazoPage]
})
export class ElegirTarjetaLazoPageModule {}
